import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import config from '../config'
import { mobileAssets } from 'src/containers/PreCache'

const Wrapper = styled.div`
  width: 100%;
  height: 100dvh;
  min-height: 100dvh;
  position: relative;
  background: url(${mobileAssets.countdownMobileBg});
  background-size: 100% 100%;
  background-position: center top;
  background-repeat: no-repeat;
  overflow: hidden;
  color: #262c65;

  .event-content {
    width: 85.7506%;
    position: absolute;
    top: 6.338dvh;
    left: 5.3435%;
    z-index: 1;
  }

  .event-title-lockup {
    /* Size by height (same axis as the countdown's dvh-based top) so the title's
       bottom edge can never overlap the countdown/overlay on short/wide viewports.
       21.2441dvh = 362/1704, matching the mobile design frame. */
    height: 21.2441dvh;
    width: auto;
    max-width: 100%;
    display: block;
  }

  .countdown-overlay {
    position: absolute;
    top: 50.8216dvh;
    right: 0;
    bottom: -2px;
    left: 0;
    border-radius: 5.0891vw 5.0891vw 0 0;
    background: linear-gradient(180deg, rgba(0, 11, 35, 0) 0%, #000b23 100%);
    backdrop-filter: blur(1.2341vw);
    -webkit-backdrop-filter: blur(1.2341vw);
  }

  .countdown-container {
    width: 85.4962%;
    position: absolute;
    top: 61.0329dvh;
    left: calc(50% + 0.5px);
    transform: translateX(-50%);
    z-index: 1;
  }

  .countdown-content {
    width: 100%;
  }

  .time-wrapper {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 8.9059vw;
    row-gap: 8.9059vw;
    align-items: start;

    .time-card {
      min-width: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4.0712vw;

      .digit-row {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 3.9453vw;
      }

      .digit {
        box-sizing: border-box;
        width: 16.2796vw;
        aspect-ratio: 63.979 / 86.829;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0.194vw solid #e5e7eb;
        border-radius: 2.799vw;
        background: #fff;
        box-shadow: inset -0.194vw -0.194vw 1.2405vw rgba(0, 0, 0, 0.1);
        color: #262c65;
        font-family: 'Din', 'DIN', sans-serif;
        font-size: 15.5038vw;
        font-weight: 700;
        line-height: normal;
      }

      p {
        width: 100%;
        font-family: 'Din', 'DIN', sans-serif;
        font-weight: 400;
        color: #fff;
        font-size: 5.5234vw;
        line-height: normal;
        margin: 0;
        text-transform: uppercase;
        text-align: center;
      }
    }
  }
`

export default function CountdownTimerMobile() {
  const calculateTimeLeft = () => {
    const { year, month, day, hour, minute } = config.EVENT_START_TIME
    const difference = +new Date(year, month - 1, day, hour, minute, 0, 0) - +new Date()
    let timeLeft = {}

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      }
    }

    return timeLeft
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    const timer = setTimeout(() => {
      const newTimeLeft = calculateTimeLeft()
      setTimeLeft(newTimeLeft)

      // Check if countdown has reached zero and refresh page
      if (Object.keys(newTimeLeft).length === 0) {
        window.location.reload()
      }
    }, 1000)

    // Cleanup function to clear the timer
    return () => clearTimeout(timer)
  }, [timeLeft])

  const timerComponents = []

  Object.keys(timeLeft).forEach((interval) => {
    if (isNaN(timeLeft[interval])) {
      return
    }

    const digits = String(timeLeft[interval]).padStart(2, '0')

    timerComponents.push(
      <div className="time-card" key={interval} aria-label={`${digits} ${interval}`}>
        <div className="digit-row" aria-hidden="true">
          {digits.split('').map((digit, index) => (
            <span className="digit" key={`${interval}-${index}`}>
              {digit}
            </span>
          ))}
        </div>
        <p aria-hidden="true">{interval}</p>
      </div>
    )
  })

  const eventStarted = !timerComponents.length

  if (eventStarted) {
    return <></>
  }

  return (
    <Wrapper>
      <div className="event-content">
        <img
          className="event-title-lockup"
          src={mobileAssets.countdownMobileTitle}
          alt="National Tax Conference 2026 — 26th Edition. Future-Ready Tax: Driving Trust, Transparency and Transformation"
        />
      </div>
      <div className="countdown-overlay" aria-hidden="true" />
      <div className="countdown-container">
        <div className="countdown-content">
          <div className="time-wrapper">{timerComponents.length && timerComponents}</div>
        </div>
      </div>
    </Wrapper>
  )
}
